import styled from 'styled-components'

const StyledSectionTitleContainer = styled.div`
	position: relative;
	margin: 50px 0px;
`

const StyledSectionTitle = styled.h2`
	margin: 20px 0px;
	padding: 0 20px;
	position: absolute;
	top: -50%;
	left: 50%;
	display: inline-block;
	transform: translate(-50%, -50%);
	background-color: rgb(248, 249, 243);
	font-family: Calibry Light;
`

export function SectionTitle({ id = undefined, children }) {
	return (
		<StyledSectionTitleContainer
			id={id}
			style={{
				position: 'relative',
			}}
		>
			<hr
				style={{
					width: '100%',
				}}
			/>
			<StyledSectionTitle>{children}</StyledSectionTitle>
		</StyledSectionTitleContainer>
	)
}

const StyledParagraph = styled.p`
	&:first-child {
		margin-top: 0;
	}

	text-align: justify;
	font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
`

export function Paragraph({
	bold = false,
	children,
	className = '',
	style = {},
}) {
	return (
		<StyledParagraph bold={bold} className={className} style={style}>
			{children}
		</StyledParagraph>
	)
}

export const ContentTitle = styled.h3`
	text-transform: uppercase;
	margin-top: 20px;
	margin-bottom: 10px;
	font-size: 1em;
`

export const Link = styled.a`
	cursor: pointer;
	color: black;
	text-decoration: none;
	font-weight: bold;
`
